/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileRefreshCheck = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M17 20h-2.226c.822.894 1.748 1 2.115 1l.11-.004c.586-.041 1.657-.407 2.057-1.549l1.888.661c-.767 2.192-2.777 2.816-3.853 2.885l-.202.007c-.636 0-1.79-.173-2.889-1.004V23h-2v-5h5z" />
        <path d="M20 7.586V11h-2V9h-5V4H6v16h4v2H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M22 18h-5v-2h2.226c-.68-.74-1.432-.94-1.88-.987L17.112 15c-.55 0-1.74.335-2.167 1.553l-1.888-.661C13.874 13.554 16.106 13 17.11 13l.213.006a4.94 4.94 0 0 1 2.676.997V13h2zm-8.293-6.293L10 15.414l-2.707-2.707 1.414-1.414L10 12.586l2.293-2.293z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileRefreshCheck as FileRefreshCheck };
